module.exports = __webpack_public_path__ + "img/maolusimayi.40e5467c.png";